define('utils/bind-manager',['jquery'],
    function () {
        var BindManager = (function () {
            function BindMng () {}

            /**
             * Holds all the bindings
             *
             * @property bindings
             * @type {Array}
             */
            BindMng.prototype.bindings = [];

            /**
             * Contains callback methods to be called once a rebind
             * is made
             *
             * @property rebindCallbacks
             * @type {Array}
             */
            BindMng.prototype.rebindCallbacks = [];

            /**
             * Add a new binding
             *
             * @method add
             * @param el
             * @param event
             * @param handler
             * @return {int} i Index of the added binding
             */
            BindMng.prototype.add = function (el, event, handler) {
                var i = this.bindings.length;

                this.bindings.push({
                    element: el,
                    event: event,
                    handler: handler
                });

                return i;
            };

            /**
             * Perform all registered binds
             *
             * @method bind
             */
            BindMng.prototype.bind = function () {
                var binding, el;

                for (var i = 0; i < this.bindings.length; i++) {
                    binding = this.bindings[i];

                    if (typeof binding.element === 'string') {
                        el = $(binding.element);
                    } else {
                        el = binding.element;
                    }

                    el.on(binding.event, binding.handler);
                }
            };

            /**
             * Unbind all bindings
             *
             * @method unbind
             */
            BindMng.prototype.unbind = function () {
                var binding;

                for (var i = 0; i < this.bindings.length; i++) {
                    binding = this.bindings[i];

                    $(binding.element).off(binding.event);
                }
            };

            /**
             * Unbind and rebind all bindings
             *
             * @method rebind
             */
            BindMng.prototype.rebind = function (callback) {
                if (callback === undefined) {
                    this.unbind();
                    this.bind();

                    for (var i = 0; i < this.rebindCallbacks.length; i++) {
                        this.rebindCallbacks[i]();
                    }
                } else {
                    this.rebindCallbacks.push(callback);
                }
            };

            return BindMng;
        })();

        return new BindManager();
    }
);
